const HasntReturned = Symbol('HasntReturned');

export default function once(fn) {
  /** @type {any} */
  let returnValue = HasntReturned;

  return async (...args) => {
    if (returnValue === HasntReturned) {
      returnValue = await fn(...args);
    }
    return returnValue;
  };
}
